import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex'
import { TokenRefresher } from '~/utils/auth/refresher'
import { AuthMutationTypes, AuthActionTypes } from './account/auth'
import { generateSetCookieString } from '~/utils/auth/helper'

export interface RootState {}

export const state = (): RootState => ({
  ...(<RootState>{})
})

export type RootStateActionContext = ActionContext<RootState, RootState>

export const getters: GetterTree<RootState, RootState> = {}

export const mutations: MutationTree<RootState> = {}

export const actions: ActionTree<RootState, RootState> = {
  async nuxtServerInit(_, { res, app }) {
    const cookies: Record<string, string> = app.$cookies.getAll()
    if (cookies['JWT-refresh-token']) {
      const refresher = TokenRefresher.fromNuxtApp(app)
      try {
        const { jwtCookie, refreshTokenCookie, refreshed } =
          await refresher.refreshIfNeeded(cookies)
        if (refreshed && jwtCookie && refreshTokenCookie) {
          app.$cookies.set('JWT', jwtCookie.value, {
            httpOnly: jwtCookie.httpOnly,
            secure: jwtCookie.secure,
            sameSite: jwtCookie.sameSite,
            path: jwtCookie.path,
            domain: jwtCookie.domain,
            expires: jwtCookie.expires,
            maxAge: jwtCookie.maxAge
          })
          app.store.commit(`account/auth/${AuthMutationTypes.SET_LOGGED_IN}`, jwtCookie.value)
          res.setHeader('Set-Cookie', [
            generateSetCookieString(jwtCookie),
            generateSetCookieString(refreshTokenCookie)
          ])
        }
      } catch (error) {
        // Clear auth cookies and set logged out state if refresh fails
        app.$cookies.remove('JWT')
        app.$cookies.remove('JWT-refresh-token')
        await app.store.dispatch(`account/auth/${AuthActionTypes.LOG_OUT}`, {
          onPrem: app.$config.onPrem
        })
        res.setHeader('Set-Cookie', [
          'JWT=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT',
          'JWT-refresh-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT'
        ])
      }
    }
  }
}
